module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('entity-page', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progress),
      expression: "progress"
    }],
    attrs: {
      "id": "page__doom-prices-settings"
    }
  }, [_c('template', {
    slot: "header-right"
  }, [_c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'xmark'],
      "danger-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'check'],
      "success-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.save
    }
  })], 1), _vm._v(" "), _c('FlexTabs', {
    attrs: {
      "tabs": _vm.tabs,
      "min": ""
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }), _vm._v(" "), (_vm.activeTab === 'tab-logs') ? _c('ZModulePropertiesLogs', {
    attrs: {
      "module": this.module,
      "properties": _vm.properties
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form && _vm.activeTab === 'tab-settings') ? _c('div', {
    staticClass: "page__doom-prices-settings__settings"
  }, [_c('z-module-properties-input', {
    ref: "inputs-price",
    attrs: {
      "properties": _vm.props.price
    },
    model: {
      value: (_vm.form),
      callback: function($$v) {
        _vm.form = $$v
      },
      expression: "form"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('z-module-properties-input', {
    ref: "inputs-display",
    staticClass: "col-6",
    attrs: {
      "properties": _vm.props.display
    },
    model: {
      value: (_vm.form),
      callback: function($$v) {
        _vm.form = $$v
      },
      expression: "form"
    }
  }), _vm._v(" "), _c('z-module-properties-input', {
    ref: "inputs-disable",
    staticClass: "col-6",
    attrs: {
      "properties": _vm.props.disable
    },
    model: {
      value: (_vm.form),
      callback: function($$v) {
        _vm.form = $$v
      },
      expression: "form"
    }
  })], 1)], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe0ca30c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/cost/views/DoomPricesSettings.vue
// module id = 1283
// module chunks = 0